export const errorState = {
  name: 'errors',
  url: '/errors/:code',
  views: {
    'main@': 'errorComponent',
  },
}



// WEBPACK FOOTER //
// ./app/errors/errors.state.js